import { ReactComponent as HHLogo } from './assets/logo_HH.svg';
import styles from './Logo.module.scss';

function Logo() {
  return (
    <div className={styles.logoWrapper}>
      <div className={styles.logo}>
        <HHLogo fill="#FFFFFF" />
      </div>
      <div className={styles.subtitle}>Social Work</div>
    </div>
  );
}

export default Logo;
